import { useLocalStorage } from 'helpers/reactUseHelper';

export type SideBarMode = 'alwaysExpanded' | 'preferCollapsed';
export type ToggleSideBarMode = () => void;

export const useSideBarMode = (
    isSmallScreen: boolean,
): [SideBarMode, ToggleSideBarMode] => {
    const [sideBarMode, setSideBarMode] = useLocalStorage<SideBarMode>(
        'sideBarMode',
        isSmallScreen ? 'preferCollapsed' : 'alwaysExpanded',
    );

    const toggleSideBarMode = () => {
        if (isSmallScreen) return;

        setSideBarMode(
            sideBarMode === 'preferCollapsed'
                ? 'alwaysExpanded'
                : 'preferCollapsed',
        );
    };

    return [
        isSmallScreen ? 'preferCollapsed' : sideBarMode ?? 'alwaysExpanded',
        toggleSideBarMode,
    ];
};
